import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import useDebouncedCallback from 'hooks/useDebouncedCallback';
import { toTitleCase } from 'utils/common';
import { documentExpiryStatusOptions, documentStatusOptions } from 'utils/constants';
import { expiryInLabel } from '../components/expiryWindow';

const labelFor = (options, value) =>
    options.find(option => String(option.value) === String(value ?? ''))?.label || '';

export default function useDocumentFilter(pageSettings , setPageSettings, documentType = []) {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        userData, userDataLoading,     
        documentSubType, documentSubTypeLoading,
        costCenter, costCenterLoading
        
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false)
    const [isFilterDirty, setIsFilterDirty] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },    
    {
        key: "issue_date_before",
        label: "Issued Before",
        value: searchParams.get("issue_date_before") || ""
    },
    {
        key: "issue_date_after",
        label: "Issued After",
        value: searchParams.get("issue_date_after") || ""
    },
    {
        key: "expiry_date_before",
        label: "Expiry Before",
        value: searchParams.get("expiry_date_before") || ""
    },
    {
        key: "expiry_date_after",
        label: "Expiry After",
        value: searchParams.get("expiry_date_after") || ""
    },
    {
        key: "document_type",
        label: toTitleCase(searchParams.get("document_type") || ""),
        value: searchParams.get("document_type") || ""
    },
    // {
    //     key: "document_sub_type",
    //     label: searchParams.get("document_sub_type") || "",
    //     value: searchParams.get("document_sub_type") || ""
    // },
    {
        key: "company_user",
        label: searchParams.get("company_user") || "",
        value: searchParams.get("company_user") || ""
    },
    {
        key: "cost_center",
        label: searchParams.get("cost_center") || "",
        value: searchParams.get("cost_center") || ""
    },
    {
        key: "employee_status",
        label: toTitleCase(searchParams.get("employee_status") || ""),
        value: searchParams.get("employee_status") || ""
    },
    {
        key: "expiry_status",
        label: labelFor(documentExpiryStatusOptions, searchParams.get("expiry_status")),
        value: searchParams.get("expiry_status") || ""
    },
    {
        key: "expiry_in",
        label: expiryInLabel(searchParams.get("expiry_in")),
        value: searchParams.get("expiry_in") || ""
    },
    {
        key: "document_status",
        label: labelFor(documentStatusOptions, searchParams.get("document_status")),
        value: searchParams.get("document_status") || ""
    }
  ]);

  useEffect(()=>{

    if(!documentSubTypeLoading && !userDataLoading && !costCenterLoading){
      
        console.log(searchParams, "------searchParams")
     
        let documentTypeId = searchParams.get("document_type") || ""
        let selectedDocumentType = documentTypeId ? [...documentType].find(item=>item.id == documentTypeId) : null
        
        let userId = searchParams.get("company_user") || ""
        let selectedUserData = userId ? [...userData].find(item=>item.id == userId) : null
        
        let documentSubTypeId = searchParams.get("document_sub_type") || ""
        let selectedDocumentSubType = documentSubTypeId ? [...documentSubType].find(item=>item.id == documentSubTypeId) : null
        
        let costCenterId = searchParams.get("cost_center") || ""
        let selectedCostCenter = costCenterId ? [...costCenter].find(item=>item.id == costCenterId) : null
    
        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            {
                key: "issue_date_after",
                label: "Issued After",
                value: searchParams.get("issue_date_after") || ""
            },
            {
                key: "issue_date_before",
                label: "Issued before",
                value: searchParams.get("issue_date_before") || ""
            },
            {
                key: "expiry_date_after",
                label: "Expiry After",
                value: searchParams.get("expiry_date_after") || ""
            },
            {
                key: "expiry_date_before",
                label: "Expiry before",
                value: searchParams.get("expiry_date_before") || ""
            },
            {
                key: "document_type",
                label: selectedDocumentType?.name || "",
                value: documentTypeId
            },
            {
                key: "document_sub_type",
                label: selectedDocumentSubType?.name || "",
                value: documentSubTypeId
            },
            {
                key: "company_user",
                label: selectedUserData ? `${selectedUserData.first_name} ${selectedUserData.last_name}` : "",
                value: userId
            },
            {
                key: "cost_center",
                label: selectedCostCenter?.name || "",
                value: costCenterId
            },
            {
                key: "employee_status",
                label: toTitleCase(searchParams.get("employee_status") || ""),
                value: searchParams.get("employee_status") || ""
            },
            {
                key: "expiry_status",
                label: labelFor(documentExpiryStatusOptions, searchParams.get("expiry_status")),
                value: searchParams.get("expiry_status") || ""
            },
            {
                key: "expiry_in",
                label: expiryInLabel(searchParams.get("expiry_in")),
                value: searchParams.get("expiry_in") || ""
            },
            {
                key: "document_status",
                label: labelFor(documentStatusOptions, searchParams.get("document_status")),
                value: searchParams.get("document_status") || ""
            }
          ]
          setFilters(_filters)
    }

 
  },[
    userData,   
    documentSubType,
    costCenter,
    documentType,
    documentSubTypeLoading,
    userDataLoading,
    costCenterLoading,
    searchParams
  ])

  const handleFilterChange =  (data, key, make_call=false) => {
    console.log( "AAAA", data)

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    if (!selectedFilter) return

    if (Array.isArray(data)) {
        // Multi-select: keep the option objects; filterHandler joins the ids.
        selectedFilter['label'] = ""
        selectedFilter['value'] = data
    } else {
        selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data?.value || ""
    }
    setFilters(_filters)
    console.log(_filters, "-----filtersssss")
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }


  };
  const pageSettingsRef = useRef(pageSettings);

  useEffect(() => {
    pageSettingsRef.current = pageSettings;
  }, [pageSettings]);

  const handleInputChange = useDebouncedCallback((data, key, make_call=false) => {
    setFilters(prevFilters => {
        const _filters = [...prevFilters]
        const selectedFilter = _filters.find(item=> item.key === key)
        if (selectedFilter) {
            selectedFilter['label'] = key
            selectedFilter['value'] = data
        }

        if(make_call){
            setPageSettings({
                ...pageSettingsRef.current,
                page:1,
                filters: _filters
            })
        }

        return _filters
    })
    if(!make_call){
      setIsFilterDirty(true)
    }
  }, 500)

  const handleDateChange = (data, key, make_call=false) => {


    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }

  // Set several filter keys in one go (used by the expiry summary tiles so
  // picking a tile replaces the other expiry filter instead of stacking).
  const applyFilterValues = (entries, make_call = true) => {
    const _filters = filters.map(filter => ({ ...filter }))
    entries.forEach(({ key, data }) => {
        const selectedFilter = _filters.find(item => item.key === key)
        if (!selectedFilter) return
        selectedFilter.label = data?.label || ""
        selectedFilter.value = data?.value || ""
    })
    setFilters(_filters)
    if (make_call) {
        setPageSettings({
            ...pageSettingsRef.current,
            page: 1,
            filters: _filters
        })
    } else {
        setIsFilterDirty(true)
    }
  }

  // Clear All only resets the draft fields inside the drawer - it must
  // NOT trigger a search. The actual API call happens when the user
  // clicks Apply Filter.
  const handleClearAll = () => {
    const hadValues = filters.some(filter => filter.key !== "search" && (Array.isArray(filter.value) ? filter.value.length > 0 : !!filter.value))
    let clearedFilters = filters.map(filter => ({
      ...filter,
      value: Array.isArray(filter.value) ? [] : "",
      label: filter.key === "search" ? "Search term" : ""
    }))
    setFilters(clearedFilters)
    if(hadValues){
      setIsFilterDirty(true)
    }
  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange,
    handleClearAll,
    applyFilterValues,
    isFilterDirty, setIsFilterDirty
  };
}
